import Pages from '@/router/Pages';
import BookingOrder from "../../views/booking_order/BookingOrder";
import Auth from '@/security/Authentication';
import Roles from "../../security/Roles";
import ChangeInformation from "../../views/change_end_user_information/ChangeInformation";
import BookingConfirm from "../../views/booking_confirm/BookingConfirm";
import ChangeEmail from "../../views/change_email/ChangeEmail";
import MyPage from '@/views/my_page/MyPage';
import ChangePassword from "../../views/change_password/ChangePassword";
import ConfirmToChangeEmail from "../../views/change_email/components/ConfirmToChangeEmail";
import RulesAtMyPage from "../../views/rules_at_my_page/RulesAtMyPage";
import CommerceLawRules from "../../views/commerce_law_rules/CommerceLawRules";
import ChangeBookingDate from "../../views/booking_confirm/ChangeBookingDate";
import ChangePasswordAfterConfirm from "../../views/reset_password/components/ChangePasswordAfterConfirm";

let EndUserRouter = [
    {
        ...Pages.orderBooking,
        component: BookingOrder,
        meta: {
            title: "Booking Order",
        }
    },
    {
        ...Pages.changeInformation,
        component: ChangeInformation,
        meta: {
            title: "Change information",
        }
    },
    {
        ...Pages.bookingConfirm,
        component: BookingConfirm,
        meta: {
            title: "Confirm booking",
        }
    },
    {
        ...Pages.oldBookingConfirm,
        component: BookingConfirm,
        meta: {
            title: "Confirm old booking",
        }
    },
    {
        ...Pages.changeEmail,
        component: ChangeEmail,
        meta: {
            title: "Change email",
        }
    },
    {
        ...Pages.myPage,
        component: MyPage,
        meta: {
            title: "My Page"
        }
    },
    {
        ...Pages.changePassword,
        component: ChangePassword,
        meta: {
            title: "Change password"
        }
    },

    {
        ...Pages.confirmToChangeEmail,
        component: ConfirmToChangeEmail,
        meta: {
            title: "Confirm to change email"
        }
    },

    {
        ...Pages.viewSystemRules,
        component: RulesAtMyPage,
        meta: {
            title: "System rules"
        }
    },
    {
        ...Pages.changeBookingDate,
        component: ChangeBookingDate,
        meta: {
            title: "Change booking date"
        }
    },
];

EndUserRouter.forEach(route => {
    route.meta.authorities = [Roles.END_USER]
});

export default EndUserRouter;
